module.exports = __webpack_public_path__ + "media/images/pages/ic-arrow-left-47d8cbc63d146ee7e4f233692725990b.png";